import React from 'react';

/**
 * Per-cashier parked-carts tray (POS multi-cart). Each parked cart shows a
 * number, the time it was parked, item count, attached customer, and total.
 * Tap the row to RECALL it (becomes the active cart, re-derived server-side);
 * the ✕ discards it. Renders nothing when there are no parked carts.
 */
export interface ParkedCart {
  id: number;
  transaction_number: string;
  parked_at: string;
  item_count: number;
  total: string;
  customer_name: string | null;
}

interface Props {
  carts: ParkedCart[];
  onRecall: (id: number) => void;
  onDiscard: (id: number) => void;
}

const fmtTime = (iso: string): string => {
  try {
    return new Date(iso).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  } catch {
    return '';
  }
};

export const ParkedCartsTray: React.FC<Props> = ({ carts, onRecall, onDiscard }) => {
  if (!carts || carts.length === 0) return null;
  return (
    <div data-testid="parked-carts-tray" style={{ marginBottom: 8 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: '#555', marginBottom: 4 }}>
        Parked carts ({carts.length})
      </div>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {carts.map((c, i) => (
          <div key={c.id} style={{
            border: '1px solid #D97706', borderRadius: 6, background: '#FFFBEB',
            padding: '4px 8px', fontSize: 12, display: 'flex', alignItems: 'center', gap: 6,
          }}>
            <button
              onClick={() => onRecall(c.id)}
              title="Recall this cart"
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#92400E', fontWeight: 600, padding: 0 }}
            >
              #{i + 1} — {fmtTime(c.parked_at)} · {c.item_count} item{c.item_count === 1 ? '' : 's'}
              {c.customer_name ? ` · ${c.customer_name}` : ''} · ${parseFloat(c.total).toFixed(2)}
            </button>
            <button
              onClick={() => onDiscard(c.id)}
              title="Discard this cart"
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#b91c1c', fontWeight: 700 }}
            >
              ✕
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
